import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {Observable} from 'rxjs/Observable';
import {DataService} from '@cosbeni/database';
import {LotasConfig} from '../config/lotas.config';

@Pipe({
    name: 'secure'
})
export class SecurePipe implements PipeTransform {

    constructor(private _sanitizer: DomSanitizer, public dataService: DataService) {
    }

    transform(url: string) {

        return new Observable<string>((observer) => {
            // This is a tiny blank image
            observer.next('data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==');

            // The next and error callbacks from the observer
            const {next, error} = observer;

            this.dataService.getBlob({}, LotasConfig.SERVER_URL + '/rest/lotas/range/image/' + url).subscribe(response => {
                const reader: any = new FileReader();
                reader.readAsDataURL(response);
                reader.onloadend = function () {
                    observer.next(this._sanitizer.bypassSecurityTrustUrl(reader.result));
                }.bind(this);
            });

            return {
                unsubscribe() {
                }
            };
        });
    }
}
